import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import InputGroup from "editor/components/InputGroup";
import RevisionsList from "editor/components/RevisionsList";

import styles from "./PreviousVersions.css";

class PreviousVersions extends React.Component {
  render() {
    return (
      <div className={styles.root}>
        <InputGroup
          headerText="Previous versions"
          inputs={[
            <>
              <RevisionsList
                disabled={this.props.status.isReadOnly}
                getBaseUrl={this.props.getBaseUrl}
                form={this.props.form}
              />
            </>,
          ]}
        />
      </div>
    );
  }
}

PreviousVersions.propTypes = {
  getBaseUrl: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
  id: PropTypes.string,
  form: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  status: state.editor.status,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviousVersions);
